import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react';

import { getFilledIcon } from '../../lib/icon-utils';
import { cn } from '../../lib/utils';

export interface LoamifyIconProps {
  icon: IconSvgElement;
  active?: boolean;
  size?: number | string;
  className?: string;
  strokeWidth?: number;
}

export function LoamifyIcon({
  icon,
  active = false,
  size = 20,
  className,
  strokeWidth = 1.75,
}: LoamifyIconProps) {
  return (
    <HugeiconsIcon
      icon={icon}
      altIcon={getFilledIcon(icon)}
      showAlt={active}
      size={size}
      strokeWidth={strokeWidth}
      className={cn('shrink-0', className)}
    />
  );
}
